<template>
  <div
    class="footer flex flex-col-reverse justify-between w-full md:flex-row absolute bottom-0 right-0 left-0"
  >
    <ul
      class="footer__menu flex-row justify-center items-center md:items-stretch md:items-stretch md:text-sm md:text-white"
    >
      <li>Copyright @ {{ (new Date()).getFullYear() }} - Corbet</li>
      <li>
        <router-link
          class="footer__link no-underline ml-1"
          to="/mentions-legales"
          >Mentions Légales</router-link
        >
      </li>
      <li>
        <router-link class="footer__link no-underline ml-1" to="/liens-utiles"
          >Liens Utiles</router-link
        >
      </li>
    </ul>

    <!-- footer mobile -->
    <ul
      class="footer__menu--mobile flex flex-col items-stretch md:hidden text-center items-center"
    >
      <li class="bg-brown"></li>
      <li class="bg-maquamarine">
        <router-link class="footer__link no-underline" to="/liens-utiles"
          >Liens Utiles</router-link
        >
      </li>
      <li class="bg-sandybrown">
        <router-link class="footer__link no-underline" to="/mentions-legales"
          >Mentions Légales</router-link
        >
      </li>
      <li class="bg-mturquoise">Copyright @ 2020 - Corbet</li>
    </ul>

    <div class="footer__wrapLogos flex justify-between">
      <div
        v-for="logo in logos"
        :key="logo.text"
        :class="logo.wrapperClass"
        class="flex flex-col"
      >
        <div v-if="logo.text" class="hidden md:block text-center text-sm">
          {{ logo.text }}
        </div>

        <div
          v-if="logo.doubleItem === true"
          class="flex h-full justify-evenly md:justify-between"
        >
          <div
            v-for="image in logo.images"
            :key="image.name"
            :class="image.iconClass"
            class="icon"
            v-on:click="redirect(image.link)"
          >
            <!-- some background-image here -->
          </div>
        </div>

        <div
          v-else
          v-for="image in logo.images"
          :key="image.name"
          :class="image.iconClass"
          v-on:click="redirect(image.link)"
          class="flex h-full icon"
        >
          <!-- some background-image here -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      testing: 'hi',
      logos: [
        {
          wrapperClass: 'footer__logo--double w-1/4 md:w-20',
          text: 'Suivez-nous sur',
          doubleItem: true,
          images: [
            {
              name: 'linkedin',
              iconClass: 'linkedin-icon',
              link: 'https://fr.linkedin.com/company/corbet-imprimerie'
            },
            {
              name: 'google',
              iconClass: 'google-icon',
              link: 'https://www.google.fr/search?source=hp&ei=yjsfX-zJKoKqa--6gagK&q=corbet&btnK=Recherche+Google&npsic=0&rflfq=1&rlha=0&rllag=48397680,2426004,71938&tbm=lcl&rldimm=12919221240767619212&lqi=CgZjb3JiZXRaEAoGY29yYmV0IgZjb3JiZXQ&phdesc=FxLZsfZZSF0&ved=2ahUKEwjdlpm0pe7qAhVHxYUKHfUTCaUQvS4wA3oECAwQFw&rldoc=1&tbs=lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:1&rlst=f#btnK=Recherche%20Google&rlfi=hd:;si:12919221240767619212,l,CgZjb3JiZXRaEAoGY29yYmV0IgZjb3JiZXQ,y,FxLZsfZZSF0;mv:[[49.5184163,8.7111326],[45.84026730000001,-2.0025862]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:1'
            }
          ]
        },
        {
          wrapperClass: 'footer__logo--double w-1/4 md:w-30',
          text: 'Une société du groupe',
          images: [
            {
              name: 'Firopa',
              iconClass: 'firopa-icon',
              link: 'https://www.firopa.fr'
            }
          ]
        },
        {
          wrapperClass: 'footer__logo w-1/4 md:w-15',
          images: [
            {
              name: 'fabriqué en France',
              iconClass: 'madeinfrance-icon'
            }
          ]
        },
        {
          wrapperClass: 'footer__logo w-1/4 md:w-30',
          images: [
            {
              name: 'imprimvert',
              iconClass: 'imprimvert-icon'
            }
          ]
        }
      ]
    }
  },
  methods: {
    redirect: function (to) {
      if (to) {
        window.open(to, '_blank')
      }
    }
  }
}
</script>

<style lang="css">
.footer {
  background-color: #ffffff;
  height: 35vw;
  z-index: 0;
}

.footer__menu {
  display: none;
}

.footer__menu--mobile li {
  height: 5.5vw;
  font-size: 3.5vw;
  color: #1c1c1c;
}

.footer__wrapLogos {
  flex-grow: 1;
  height: 9vw;
  padding: 1%;
}

.footer__logo {
  display: flex;
  flex-direction: column;
}

.footer__logo--double {
  padding: 1.5% 0;
}

.linkedin-icon {
  background-image: url(/static/logos/linkedin@2x.png);
  width: 35% !important;
}

.google-icon {
  background-image: url(/static/logos/google-icon@2x.png);
  width: 35% !important;
}

.firopa-icon {
  background-image: url(/static/logos/firopa@2x.png);
  width: 60% !important;
  margin: auto;
}
.madeinfrance-icon {
  background-image: url(/static/logos/fabrique-en-france.png);
  width: 100%;
}

.imprimvert-icon {
  background-image: url(/static/logos/imprim-vert-logo-feuille@2x.png);
  width: 100%;
}

@media screen and (min-width: 768px) {
  .footer {
    height: 4vw !important;
  }

  .footer__menu {
    display: flex !important;
    height: 100% !important;
    flex-basis: 50%;
    margin: 0 0 0 25%;
    background: none;
    font-size: 0.9vw !important;
    line-height: 3.1vw;
  }

  /*.footer__menu:after {
    content: none !important;
  }
  */

  .footer__link:before {
    content: "|";
    margin-right: 0.25vw;
  }

  .footer__wrapLogos {
    flex-grow: 1;
    height: 100%;
    padding: 0;
  }

  .footer:after {
    content: "";
    position: absolute;
    background-image: url(/static/footer-bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    top: 0;
    left: -10px;
    width: 80%;
    height: 100%;
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue